












import { Component, Prop, Vue } from "vue-property-decorator";
import AsideMenuItem from "@/components/AsideMenuItem.vue";

@Component({
  components: {
    AsideMenuItem
  }
})
export default class AsideMenuList extends Vue {
  @Prop({ default: false }) private isSubmenuList?: boolean;
  @Prop({ default: false }) private isSecondary?: boolean;
  @Prop({ default: () => [] }) private menu?: any[];

  menuClick(item: any) {
    this.$emit("menu-click", item);
  }
}
